(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('PhishingDashboardController', ["$scope", "widgetSettings", function ($scope, widgetSettings) {
        var resolutionUuid = '9dce8ff7-2adb-49a2-8dae-60b65e3d05e7';
        $scope.model = {
            resolution: widgetSettings.param(resolutionUuid, 'resolution') || 'month',
            eventStates: ['new'],
            enabledSaases: [],
            selectedSaases: []
        };
        $scope.$watch('model.resolution', function (newValue) {
            widgetSettings.param(resolutionUuid, 'resolution', newValue);
        });
    }]);
}());